import { HelpHintWindow } from "@/components/ui/HintWindow";
import { WatchDogHintWindowBodyPanels } from "@/components/hlidaci-pes/watchdog-page/WatchDogHintWindowBodyPanels";
import { useLanguage } from "@/context/LanguageContext";

export type WatchDogTopHintWindowProps = {
  watchDogCount: number;
  activeViewLabel: string;
  activeViewDescription: string;
  isOpen: boolean;
  onToggle: () => void;
};

export function WatchDogTopHintWindow({
  watchDogCount,
  activeViewLabel,
  activeViewDescription,
  isOpen,
  onToggle,
}: WatchDogTopHintWindowProps) {
  const { language } = useLanguage();
  const copy = {
    cs: {
      help: "Nápověda",
      title: "Tipy k hlídacímu psovi",
      description: "Kontext, doporučení a rychlá akce nad hlavním obsahem.",
      hideHelp: "Skrýt nápovědu",
    },
    en: {
      help: "Help",
      title: "Watchdog tips",
      description:
        "Context, recommendations, and quick action above the main content.",
      hideHelp: "Hide help",
    },
  }[language];

  if (!isOpen) return null;

  return (
    <HelpHintWindow
      eyebrow={copy.help}
      title={copy.title}
      description={copy.description}
      closeLabel={copy.hideHelp}
      onClose={onToggle}
    >
      <WatchDogHintWindowBodyPanels
        watchDogCount={watchDogCount}
        activeViewLabel={activeViewLabel}
        activeViewDescription={activeViewDescription}
        isTop
      />
    </HelpHintWindow>
  );
}
